import React from 'react';
import KpisInfo from './Kpis/KpisInfo/KpisInfo';
import DoughnutChart from '../Charts/DouhnutChart/DoughnutChart';
import KpiTop from './Kpis/KpiTop/KpiTop';
import BarChart from '../Charts/BarChart/BarChart';

function Dashboard() {
  return (
    <div className="w-full flex flex-col">
      {/* <KpisInfo />
      <div className="flex">
        <div className="w-2/3 sm:pr-8">
          <BarChart />
        </div>
        <div className="w-1/3">
          <KpiTop />
        </div>
      </div>
      <DoughnutChart /> */}
    </div>
  );
}

Dashboard.auth = true;

export default Dashboard;
